import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { FaChartBar, FaChalkboardTeacher, FaBookOpen, FaGlobe, FaCreditCard, FaAward, FaMobileAlt, FaUserClock, FaRobot } from 'react-icons/fa';
import '../style.css';

function LinguaHub() {
  const features = [
    { icon: <FaChartBar />, title: "Seguimiento del Progreso", description: "Monitorea tu avance con informes personalizados y gráficos interactivos.", benefit: "Saber tu progreso te ayuda a mantener la motivación y trabajar en áreas específicas." },
    { icon: <FaChalkboardTeacher />, title: "Clases con Profesores Expertos", description: "Accede a clases en línea y presenciales con profesores certificados.", benefit: "Formación de calidad para dominar el idioma con un enfoque práctico." },
    { icon: <FaBookOpen />, title: "Recursos de Aprendizaje", description: "Accede a libros, videos y materiales exclusivos dentro de la plataforma.", benefit: "Todos los recursos que necesitas a tu alcance para un aprendizaje continuo." },
    { icon: <FaGlobe />, title: "Accesibilidad Global", description: "Estudia desde cualquier lugar sin limitaciones geográficas.", benefit: "La educación flexible te permite aprender a tu ritmo desde cualquier lugar." },
    { icon: <FaCreditCard />, title: "Gestión de Pagos Segura", description: "Realiza seguimiento a tus recibos y pagos por nivel.", benefit: "Sigue tu historial de pagos desde la plataforma." },
    { icon: <FaAward />, title: "Certificaciones Internacionales", description: "Obtén certificados reconocidos internacionalmente para cada curso completado.", benefit: "Tus logros serán reconocidos globalmente y añadirán valor a tu CV." },
    { icon: <FaMobileAlt />, title: "Acceso 24/7", description: "Disponible en computadoras, tablets y celulares.", benefit: "Aprende sin restricciones y aprovecha cada momento para estudiar." },
    { icon: <FaUserClock />, title: "Horarios 100% Flexibles", description: "Toma clases en vivo o accede a las grabaciones en cualquier momento.", benefit: "Ajusta tu aprendizaje a tu ritmo de vida sin perder contenido." },
    { icon: <FaRobot />, title: "Chatbot de IA", description: "Asistente virtual disponible las 24 horas para resolver tus dudas.", benefit: "Recibe ayuda instantánea sobre clases, actividades y funcionalidades." },
  ];

  return (
    <div className="page-wrapper">
      <Helmet>
        <title>LinguaHub | Plataforma Digital de Aprendizaje — Culturlingua</title>
        <meta name="description" content="LinguaHub es la plataforma digital de Culturlingua para seguimiento de clases, pagos, recursos y aprendizaje online." />
      </Helmet>

      <div className="page-hero" style={{position:'relative', overflow:'hidden'}}>
        <div className="section-tag">Plataforma Digital</div>
        <h1>Conoce LinguaHub</h1>
        <p>Tu nuevo seguimiento de aprendizaje basado en tecnología. Clases, pagos, recursos y más.</p>
        <div style={{marginTop:'32px'}}>
          <a href="https://linguahub.culturlingua.com/" target="_blank" rel="noopener noreferrer" className="btn-glow">
            Entrar a LinguaHub →
          </a>
        </div>
      </div>

      <section style={{background:'var(--cream)', padding:'80px 48px'}}>
        <div style={{maxWidth:'1200px', margin:'0 auto'}}>

          <div style={{background:'white', borderRadius:'20px', padding:'48px', boxShadow:'0 2px 16px rgba(0,0,0,0.06)', marginBottom:'64px', maxWidth:'800px', margin:'0 auto 64px'}}>
            <div className="section-tag">¿Qué es?</div>
            <h2 className="section-headline" style={{fontSize:'1.8rem', marginBottom:'16px'}}>Una plataforma educativa completa</h2>
            <p style={{color:'var(--muted)', lineHeight:'1.8'}}>
              LinguaHub es la plataforma de aprendizaje de Culturlingua diseñada para ofrecer una experiencia
              educativa completa, con herramientas interactivas, contenido personalizado y acceso a profesores
              certificados. Ya sea que desees mejorar tus habilidades o comenzar desde cero, LinguaHub te
              brinda los recursos para lograr tus metas.
            </p>
          </div>

          <div style={{textAlign:'center', marginBottom:'48px'}}>
            <div className="section-tag">Funcionalidades</div>
            <h2 className="section-headline">¿Qué puede hacer LinguaHub <em>para ti?</em></h2>
          </div>

          <div style={{display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(300px, 1fr))', gap:'20px'}}>
            {features.map((f, i) => (
              <div key={i} style={{background:'white', borderRadius:'16px', padding:'28px', boxShadow:'0 2px 12px rgba(0,0,0,0.05)', transition:'transform 0.25s, box-shadow 0.25s'}}
                onMouseEnter={e => { e.currentTarget.style.transform='translateY(-4px)'; e.currentTarget.style.boxShadow='0 12px 32px rgba(0,0,0,0.1)'; }}
                onMouseLeave={e => { e.currentTarget.style.transform=''; e.currentTarget.style.boxShadow='0 2px 12px rgba(0,0,0,0.05)'; }}
              >
                <div style={{width:'44px', height:'44px', borderRadius:'10px', background:'rgba(59,111,224,0.1)', display:'flex', alignItems:'center', justifyContent:'center', color:'var(--blue)', fontSize:'1.3rem', marginBottom:'16px'}}>
                  {f.icon}
                </div>
                <h3 style={{fontFamily:'Fraunces, serif', fontWeight:'700', fontSize:'1.05rem', color:'var(--navy)', marginBottom:'8px'}}>{f.title}</h3>
                <p style={{color:'var(--muted)', fontSize:'0.875rem', lineHeight:'1.6', marginBottom:'12px'}}>{f.description}</p>
                <p style={{color:'var(--blue)', fontSize:'0.8rem', fontWeight:'600'}}>✓ {f.benefit}</p>
              </div>
            ))}
          </div>

          <div style={{background:'var(--navy)', borderRadius:'20px', padding:'48px', textAlign:'center', marginTop:'64px'}}>
            <h3 style={{fontFamily:'Fraunces, serif', fontSize:'1.8rem', color:'white', fontWeight:'900', marginBottom:'12px'}}>
              ¿Listo para empezar?
            </h3>
            <p style={{color:'rgba(255,255,255,0.6)', marginBottom:'32px'}}>
              Entra a LinguaHub y lleva tu aprendizaje al siguiente nivel.
            </p>
            <a href="https://linguahub.culturlingua.com/" target="_blank" rel="noopener noreferrer" className="btn-glow">
              Acceder a LinguaHub →
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default LinguaHub;
